import Component from '../Component';
import $ from '../../vendor/CustomJquery';
import generatePassword from 'password-generator';

export default class PasswordGenerator extends Component {

  configure() {
    return super.configure();
  }

  initialize() {
    this.subscribeToEvents();
    return super.initialize();
  }

  subscribeToEvents() {
    $(document).on('click', '.is-password-generator', (event) => {
      return this.onClick(event);
    });
  }

  onClick(event) {

    let self = $(event.currentTarget);

    this.App.Form.PasswordSwitch.show(self);

    let password = generatePassword(5 + Math.floor(Math.random() * 3), true);

    self.closest('.field').find('input').val(password);

    event.preventDefault();
  }

}